import { mapPeaks } from './mapPeaks';
export function updatePeaks(spectrum) {
    spectrum.peaks.values = mapPeaks(spectrum.peaks.values, spectrum, {
        checkIsExisting: false,
        shiftTarget: 'current',
    });
}
//# sourceMappingURL=updatePeaks.js.map